import { render, staticRenderFns } from "./order-modal-delivery.vue?vue&type=template&id=2cc15b03"
import script from "./order-modal-delivery.vue?vue&type=script&lang=js"
export * from "./order-modal-delivery.vue?vue&type=script&lang=js"
import style0 from "./order-modal-delivery.vue?vue&type=style&index=0&id=2cc15b03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports